<template>
  <dx-data-grid
    :data-source="vars.project"
    :show-borders="true"
    :allow-column-reordering="true"
    :allow-column-resizing="true"
    :column-auto-width="true"
    :remote-operations="true"
    @selection-changed="methods.onSelectionChanged"
  >
    <dx-column data-field="project_number" caption="프로젝트번호" />
    <dx-column data-field="contract_name" caption="계약건명" />
    <dx-column data-field="order_company" caption="발주기관" />
    <dx-column
      data-field="contract_date"
      caption="계약일자"
      data-type="date"
      format="yyyy-MM-dd"
    />
    <dx-column
      data-field="contract_begin_date"
      caption="계약기간(시작)"
      data-type="date"
      format="yyyy-MM-dd"
    />
    <dx-column
      data-field="contract_end_date"
      caption="계약기간(종료)"
      data-type="date"
      format="yyyy-MM-dd"
    />
    <dx-column data-field="contract_price" caption="계약금액" />
    <dx-column data-field="register_department" caption="등록부서" />
    <dx-column data-field="register_manager" caption="등록담당자" />
    <dx-column
      data-field="register_date"
      caption="등록일자"
      data-type="date"
      format="yyyy-MM-dd"
    />

    <dx-paging :page-size="20" />
    <dx-selection
      select-all-mode="page"
      show-check-boxes-mode="always"
      :mode="vars.mode"
    />
    <dx-filter-row :visible="true" />
  </dx-data-grid>
</template>

<script>
import { onMounted, reactive } from 'vue';

import {
  DxDataGrid,
  DxColumn,
  DxSelection,
  DxPaging,
  DxFilterRow,
} from 'devextreme-vue/data-grid';

import { getProjectRegistration } from '../../data-source/project';
import authService from '../../auth';

export default {
  props: {
    multiple: {
      type: Boolean,
      default: false,
    },
  },
  components: { DxDataGrid, DxColumn, DxSelection, DxPaging, DxFilterRow },
  setup(props, { emit }) {
    onMounted(() => {
      methods.refresh();
    });

    const vars = reactive({
      mode: props.multiple ? 'multiple' : 'single',
      project: null,
      projectFilter: [
        {
          name: 'fk_company_id',
          op: 'eq',
          val: authService._user.fk_company_id || 0,
        },
      ],
    });

    const methods = {
      refresh: async () => {
        vars.project = getProjectRegistration(vars.projectFilter);
      },
      onSelectionChanged: ({ selectedRowsData }) => {
        if (!props.multiple && selectedRowsData)
          selectedRowsData = selectedRowsData[0];
        emit('change', selectedRowsData);
      },
    };

    return {
      vars,
      methods,
    };
  },
};
</script>
